import React, { createContext, useContext } from 'react';

const ProposalProjectConfigContext = createContext(null);

export function ProposalProjectConfigProvider({ value, children }) {
  return (
    <ProposalProjectConfigContext.Provider value={value}>
      {children}
    </ProposalProjectConfigContext.Provider>
  );
}

export function useProposalProjectConfig() {
  return useContext(ProposalProjectConfigContext);
}
